import dayjs from "dayjs";

export const OUTBOUND_JSON_KEY = "callMe:outboundJson";
export const PHONE_NUMBER_KEY = "callMe:phoneNumber";

export const getDefaultOutboundJson = () => ({
  "patient": {
    "firstName": "David",
    "lastName": "Anderson",
    "ids": {
      "mock_ehr_id": "P011"
    }
  },
  "appointment": {
    "startTime": dayjs().add(3, "hour").format("YYYY-MM-DDTHH:mm:ss"),
    "ids": {
      "mock_ehr_id": "12345"
    }
  }
});

export const isOutboundJsonValid = (jsonString) => {
  try {
    const parsed = JSON.parse(jsonString?.trim());
    return !!jsonString && typeof parsed === "object" && parsed !== null;
  } catch (error) {
    return false;
  }
};

export const migrateOutboundJsonData = (assistantId) => {
  try {
    const key = `${assistantId}:${OUTBOUND_JSON_KEY}`;
    const savedData = localStorage.getItem(key);

    if (!savedData) return;

    const parsedData = JSON.parse(savedData);

    // Only update if the data has the expected structure
    if (parsedData?.appointment?.startTime?.startsWith("{date")) {
      // Update with current time + 3 hours
      parsedData.appointment.startTime = dayjs().add(3, "hour").format("YYYY-MM-DDTHH:mm:ss");
      localStorage.setItem(key, JSON.stringify(parsedData, null, 2));
    }
  } catch (error) {
    console.error("Error migrating outbound JSON data:", error);
  }
};

export const getInitialTaskData = (isOutboundAgent, assistantId) => {
  try {
    const savedTaskData = localStorage.getItem(`${assistantId}:${OUTBOUND_JSON_KEY}`);
    return isOutboundAgent && savedTaskData ? savedTaskData : JSON.stringify(getDefaultOutboundJson(), null, 2);
  } catch (error) {
    console.error("Error parsing outbound json from localStorage:", error);
    return "";
  }
};

export const getInitialPhoneNumber = () => {
  const savedPhoneNumber = localStorage.getItem(PHONE_NUMBER_KEY);
  return savedPhoneNumber ? savedPhoneNumber : "";
};
